enum TextAlignment {
  Left = 'LEFT',
  Center = 'CENTER',
  Right = 'RIGHT'
}

export default TextAlignment
